import React, { useState, useEffect } from 'react';

const AsyncColorName = ({ color, extractHexFromColor, getColorName }) => {
  const [colorName, setColorName] = useState('Loading...');

  useEffect(() => {
    const fetchColorName = async () => {
      try {
        const hexCode = extractHexFromColor(color);
        const name = await getColorName(hexCode);
        setColorName(name);
      } catch (error) {
        console.log('Failed to get color name:', error);
        setColorName(color);
      }
    };

    fetchColorName();
  }, [color, extractHexFromColor, getColorName]);

  return <>{colorName}</>;
};

export default AsyncColorName;
